import { Model } from 'infra/model'
import { makeObservable, observable } from 'mobx'
import { Id } from 'types/definitions'
import { AvailableJobProgressionFlowsDto } from '../dtos'
import { GetAdditionalProgressionFlowsAvailableForJobResponse } from '@taxfyle/api-internal/internal/job_progression_pb'

export interface AvailableInventoryItemTaxExtensionFlows {
  personalExtensionProgressionFlowAvailable: boolean
  businessExtensionProgressionFlowAvailable: boolean
  outsourcingExtensionProgressionFlowAvailable: boolean
}

export class AvailableJobProgressionFlows extends Model<
  AvailableJobProgressionFlowsDto,
  AvailableJobProgressionFlows
> {
  @observable
  jobId = Id.none

  @observable
  availableInventoryItemTaxExtensionFlows: AvailableInventoryItemTaxExtensionFlows | null =
    null

  constructor() {
    super()
    makeObservable(this)
  }

  parse(
    availableProgressionFlows: Partial<AvailableJobProgressionFlowsDto>,
  ): Partial<AvailableJobProgressionFlows> {
    return {
      jobId: availableProgressionFlows.jobId,
      availableInventoryItemTaxExtensionFlows:
        this.mapToAvailableInventoryItemTaxExtensionFlows(
          availableProgressionFlows.availableInventoryItemTaxExtensionFlows,
        ),
    }
  }

  mapToAvailableInventoryItemTaxExtensionFlows(
    availableInventoryItemTaxExtensionFlows?: GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.AsObject | null,
  ): AvailableInventoryItemTaxExtensionFlows | null {
    if (!availableInventoryItemTaxExtensionFlows) {
      return null
    }

    return {
      personalExtensionProgressionFlowAvailable:
        availableInventoryItemTaxExtensionFlows.personalExtensionProgressionFlowAvailable,
      businessExtensionProgressionFlowAvailable:
        availableInventoryItemTaxExtensionFlows.businessExtensionProgressionFlowAvailable,
      outsourcingExtensionProgressionFlowAvailable:
        availableInventoryItemTaxExtensionFlows.outsourcingExtensionProgressionFlowAvailable,
    }
  }
}
